import React from 'react';
import { Phone, Mail, MapPin, Clock, MessageCircle } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen pt-24 pb-16">
      {/* Hero Section */}
      <section className="py-16 px-4" style={{ background: 'var(--gradient-hero)' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="heading-1 mb-6">Contact Us</h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            We're here to help you with all your irrigation needs
          </p>
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-16 px-4" style={{ background: 'var(--bg-page)' }}>
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {/* Contact Details Card */}
            <div className="product-card">
              <h2 className="heading-2 mb-6">Get In Touch</h2>
              <div className="space-y-6">
                {/* Phone Numbers */}
                <div>
                  <div className="flex items-center space-x-3 mb-3">
                    <Phone className="w-6 h-6" style={{ color: 'var(--accent-text)' }} />
                    <h3 className="heading-3" style={{ fontSize: '1.125rem' }}>Phone</h3>
                  </div>
                  <div className="ml-9 space-y-2">
                    <a
                      href="tel:6382799541"
                      className="block body-medium hover:text-green-600 transition-colors"
                      style={{ color: 'var(--text-body)' }}
                    >
                      6382799541
                    </a>
                    <a
                      href="tel:7904369704"
                      className="block body-medium hover:text-green-600 transition-colors"
                      style={{ color: 'var(--text-body)' }}
                    >
                      7904369704
                    </a>
                  </div>
                </div>

                {/* WhatsApp */}
                <div>
                  <div className="flex items-center space-x-3 mb-3">
                    <MessageCircle className="w-6 h-6" style={{ color: 'var(--accent-text)' }} />
                    <h3 className="heading-3" style={{ fontSize: '1.125rem' }}>WhatsApp</h3>
                  </div>
                  <div className="ml-9">
                    <a
                      href="https://wa.me/6382799541?text=Hi,%20I'm%20interested%20in%20your%20irrigation%20products"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="body-medium hover:text-green-600 transition-colors"
                      style={{ color: 'var(--text-body)' }}
                    >
                      6382799541
                    </a>
                  </div>
                </div>

                {/* Email */}
                <div>
                  <div className="flex items-center space-x-3 mb-3">
                    <Mail className="w-6 h-6" style={{ color: 'var(--accent-text)' }} />
                    <h3 className="heading-3" style={{ fontSize: '1.125rem' }}>Email</h3>
                  </div>
                  <div className="ml-9">
                    <a
                      href="mailto:seelakariymman@gmail.com"
                      className="body-medium hover:text-green-600 transition-colors"
                      style={{ color: 'var(--text-body)' }}
                    >
                      seelakariymman@gmail.com
                    </a>
                  </div>
                </div>

                {/* Location */}
                <div>
                  <div className="flex items-center space-x-3 mb-3">
                    <MapPin className="w-6 h-6" style={{ color: 'var(--accent-text)' }} />
                    <h3 className="heading-3" style={{ fontSize: '1.125rem' }}>Location</h3>
                  </div>
                  <div className="ml-9">
                    <a
                      href="https://maps.app.goo.gl/Berr6sUCjMETggov8?g_st=awb"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="body-medium hover:text-green-600 transition-colors underline"
                      style={{ color: 'var(--text-body)' }}
                    >
                      5/202A, Vadakku Theru Kottavur,<br />
                      Adiyamankottai, Nallampalli,<br />
                      Dharmapuri, Tamil Nadu - 636807
                    </a>
                  </div>
                </div>

                {/* Business Hours */}
                <div>
                  <div className="flex items-center space-x-3 mb-3">
                    <Clock className="w-6 h-6" style={{ color: 'var(--accent-text)' }} />
                    <h3 className="heading-3" style={{ fontSize: '1.125rem' }}>Business Hours</h3>
                  </div>
                  <div className="ml-9">
                    <p className="body-medium" style={{ color: 'var(--text-body)' }}>
                      Monday - Saturday: 9:00 AM - 7:00 PM<br />
                      Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Contact Card */}
            <div className="product-card" style={{ background: 'var(--bg-section)' }}>
              <h2 className="heading-2 mb-6">Send Us a Message</h2>
              <p className="body-medium mb-6" style={{ color: 'var(--text-secondary)' }}>
                Have questions about our products or need expert advice? We're here to help!
                Choose your preferred way to reach us:
              </p>
              <div className="space-y-4">
                <a href="tel:6382799541" className="btn-primary w-full">
                  <Phone className="w-5 h-5" />
                  Call: 6382799541
                </a>
                <a href="tel:7904369704" className="btn-secondary w-full">
                  <Phone className="w-5 h-5" />
                  Call: 7904369704
                </a>
                <a
                  href="https://wa.me/6382799541?text=Hi,%20I'm%20interested%20in%20your%20irrigation%20products"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary w-full"
                  style={{ background: '#25D366' }}
                >
                  <MessageCircle className="w-5 h-5" />
                  WhatsApp Chat
                </a>
                <a href="mailto:seelakariymman@gmail.com" className="btn-secondary w-full">
                  <Mail className="w-5 h-5" />
                  Email Us
                </a>
              </div>

              <div className="mt-8 p-4 rounded-lg" style={{ background: 'var(--accent-wash)' }}>
                <p className="body-small" style={{ color: 'var(--text-body)' }}>
                  <strong>Note:</strong> For immediate assistance, please call or WhatsApp us
                  during business hours. We typically respond to emails within 24 hours.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Visit Us Section */}
      <section className="py-16 px-4" style={{ background: 'var(--bg-section)' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="heading-2 mb-4">Visit Our Office</h2>
          <p className="body-large mb-6" style={{ color: 'var(--text-secondary)' }}>
            We welcome you to visit our office in Dharmapuri / Nallampalli to discuss your
            irrigation needs in person. Our team will be happy to show you our product range
            and provide expert consultation.
          </p>
          <p className="body-medium" style={{ color: 'var(--text-body)' }}>
            <strong>Please call ahead to schedule your visit and ensure our team is available
              to assist you.</strong>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Contact;